import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class SupportService {
  public testCenterName: BehaviorSubject<string> = new BehaviorSubject<string>(
    "Imaging Center"
  );
  public testCenterNameDropdown: BehaviorSubject<string> = new BehaviorSubject<
    string
  >("IC Admin");
  public countryCode: BehaviorSubject<string> = new BehaviorSubject<string>(
    "US"
  );
  public patientname: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public showback: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public stateName: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public stateId: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public headerSubLittle: BehaviorSubject<string> = new BehaviorSubject<string>(
    "Dashboard"
  );
  public headerSignBtnHandle: BehaviorSubject<boolean> = new BehaviorSubject<
    boolean
  >(false);
  public getCityName: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public getDateChange = new BehaviorSubject<any>("");
  public getDateChange1 = new BehaviorSubject<any>("");
  public handlePatientHeader: BehaviorSubject<boolean> = new BehaviorSubject<
    boolean
  >(false);
  public isAccept = false;
  public gridSortingHeader = new BehaviorSubject<any>("");
  public adminsidemenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  public subscriptionstatus: BehaviorSubject<string> = new BehaviorSubject<
    string
  >("");
  public loginUserName: BehaviorSubject<string> = new BehaviorSubject<string>(
    ""
  );
  public sidemenuname: BehaviorSubject<string> = new BehaviorSubject<string>(
    ""
  );
  public physicianpage: BehaviorSubject<string> = new BehaviorSubject<string>(
    ""
  );
}
